import React, { useRef, useState } from 'react';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';
import { MdOutlineShoppingCart } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Logo from '../../../../assets/icons/Logo.svg?react';
import { isProprietarioProfile } from '@/helpers/accessProfileUtil';
import { VerReservasHeaderTrigger } from '@/components/OwnerReservationsPanel';
import {
    canAccessStore,
    STORE_RESERVATION_REQUIRED_MESSAGE,
} from '../../../../helpers/storeAccess';
import { useUserProfile } from '../../../../hooks/useUserData';
import { useReservationStore } from '../../../../store/reservation/reservationStore';
import { useModalAuthStore } from '../../../../store/auth/authModalStore';
import { useModalShoppingStore } from '../../../../store/shopping/modalShoppingStore';
import { useShoppingCartStore } from '../../../../store/shoppingCart/shoppingCartStore';
import { BigButton } from '../../../BigButton';
import { Divider } from '../../../Divider';
import { IconButton } from '../../../IconButton';
import Icon from '../../../ReactIcon';
import { TooltipDropdownBase } from '../../../Tooltip';
import UserOptionsDropdown from '../../../UserOptionsDropdown';
import { CardShopPopupHeader } from '../CardShopHeader';
import {
    HeaderWrapper,
    NavWrapper,
    UserAreaWrapper,
    WrapperToPopup,
} from './styles';

type HeaderLargerProps = {
    onOpenOwnerReservations?: () => void;
};

export const HeaderLarger: React.FC<HeaderLargerProps> = ({
    onOpenOwnerReservations,
}) => {
    const navigate = useNavigate();
    const navRef = useRef<HTMLDivElement>(null);
    const [popupShopIsVisible, setPopupShopIsVisible] = useState(false);
    const { setIsVisibleShoppingWave } = useModalShoppingStore();
    const { cartValues } = useShoppingCartStore();
    const activeReservation = useReservationStore(state => state.activeReservation);
    const { setIsVisibleAuthModal: setAuthOpen } = useModalAuthStore();
    const userProfile = useUserProfile();

    const user = userProfile.data;
    const totalItemsInCart = cartValues?.length || 0;

    const handleOpenShop = () => {
        if (!canAccessStore({ activeReservation })) {
            toast.warning(STORE_RESERVATION_REQUIRED_MESSAGE);
            return;
        }
        setIsVisibleShoppingWave(true);
    };

    const scrollToFooter = () => {
        const footerElement = document.getElementById('contatos-footer');
        if (footerElement) {
            footerElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };

    return (
        <>
            <WrapperToPopup ref={navRef}>
                <HeaderWrapper>
                    <Logo onClick={() => navigate('/')} cursor={'pointer'} />
                    <NavWrapper>
{/*                         <Link
                            to={'/menu-de-ondas'}
                            
                        >
                            Menu de ondas
                        </Link> */}
                        <Link
                            to={'https://mkt.surflandbrasil.com.br/multipropriedade'}
                            target="_blank"
                        >
                            Seja Proprietário
                        </Link>
                        <TooltipDropdownBase
                            content={
                                <CardShopPopupHeader
                                    close={() => {
                                        setPopupShopIsVisible(false);
                                    }}
                                />
                            }
                            offset={[0, 33]}
                            appendTo={'parent'}
                            maxWidth={'fit-content'}
                            placement="bottom"
                            onHide={() => setPopupShopIsVisible(false)}
                            onShow={() => setPopupShopIsVisible(true)}
                        >
                            <a
                                className={
                                    popupShopIsVisible
                                        ? 'expandable-link open'
                                        : 'expandable-link'
                                }
                            >
                                Loja
                                {popupShopIsVisible && <LuChevronUp />}
                                {!popupShopIsVisible && <LuChevronDown />}
                            </a>
                        </TooltipDropdownBase>
                        <Link to={''} onClick={scrollToFooter}>
                            Contato
                        </Link>
                        {/* <Link
                            to={'https://www.surflandbrasil.com.br/faq'}
                            target="_blank"
                        >
                            Dúvidas
                        </Link> */}
                    </NavWrapper>

                    <UserAreaWrapper>
                        {user &&
                            isProprietarioProfile(user) &&
                            onOpenOwnerReservations && (
                                <VerReservasHeaderTrigger
                                    onClick={onOpenOwnerReservations}
                                />
                            )}
                        <IconButton
                            onClick={handleOpenShop}
                            className="shopping-cart"
                        >
                            <Icon
                                Icon={MdOutlineShoppingCart}
                                size={'1.5rem'}
                                cursor={'pointer'}
                            />
                            {totalItemsInCart && totalItemsInCart}
                        </IconButton>
                        <Divider />
                        {!user && (
                            <div className="login-area">
                                <BigButton
                                    bgColor="primary"
                                    color="primary"
                                    onClick={() => setAuthOpen(true, 'signup')}
                                >
                                    Cadastre-se
                                </BigButton>
                                <BigButton
                                    bgColor="primary"
                                    color="primary"
                                    onClick={() => setAuthOpen(true, 'login')}
                                >
                                    Já sou cliente
                                </BigButton>
                            </div>
                        )}
                        {user && <UserOptionsDropdown />}
                    </UserAreaWrapper>
                </HeaderWrapper>
            </WrapperToPopup>
        </>
    );
};
